import { render, staticRenderFns } from "./SupplyDemandPage.vue?vue&type=template&id=41270898&scoped=true"
import script from "./SupplyDemandPage.vue?vue&type=script&lang=js"
export * from "./SupplyDemandPage.vue?vue&type=script&lang=js"
import style0 from "./SupplyDemandPage.vue?vue&type=style&index=0&id=41270898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41270898",
  null
  
)

export default component.exports